var exports = {
  "G": "FeedCreatorMark.module__mark___R0dGNl",
  "V": "FeedCreatorMark.module__glyph___R0dGNl",
};

module.exports = exports;
